<template>
  <div v-if="loaded">
    <p>{{ $t("orderInformation") }}</p>

    <b-row class="ms-0 ms-0">
      <b-col>
        <cart-action-code />
      </b-col>
    </b-row>
    <b-row
      v-for="row in orderInformationFields"
      :key="row.name"
      class="ms-0 ms-0"
    >
      <form-element
        v-for="formElement in row"
        :key="formElement.name"
        v-model="form[formElement.name]"
        :form-element="formElement"
      />
      <cart-pay-methods v-model="form.payMethodID" />
      <cart-transport-method
        v-model="form.transportID"
        :countryid="form.shipmentCountryID || form.countryID"
      />
    </b-row>
    <cart-dynamic-fields v-model="dynamicFields" />
    <div>
      <p>{{ $t("invoiceAddressDetails") }}</p>
      <b-row
        v-for="row in invoiceAddressFields"
        :key="row.name"
        class="ms-0 ms-0"
      >
        <form-element
          v-for="formElement in row"
          :key="formElement.name"
          v-model="form[formElement.name]"
          :form-element="formElement"
        />
      </b-row>
    </div>

    <div v-if="!orderInformation.shippingIsSameAsInvoiceAddress">
      <p>{{ $t("deliveryAddressDetails") }}</p>
      <address-shipment-selector
        v-model="shipmentAddress"
        :shipment-address-id="form.shipmentAddressID"
      />

      <b-row
        v-for="row in deliveryAddressFields"
        :key="row.name"
        class="ms-0 ms-0"
      >
        <form-element
          v-for="formElement in row"
          :key="formElement.name"
          v-model="form[formElement.name]"
          :form-element="formElement"
        />
      </b-row>
    </div>
  </div>
</template>

<script>
import formElement from "../form/FormElement.vue"
import orderInformationFields from "./formData/orderInformationFields"
import deliveryAddressFields from "./formData/deliveryAddressFields"
import invoiceAddressFields from "./formData/invoiceAddressFields"

import { getCustomerInvoiceAddress } from "@/services/customer"
import { BRow, BCol } from "bootstrap-vue"
import CartActionCode from "./CartOrderInformationActionCode"
import AddressShipmentSelector from "../addresses/AddressShipmentSelector"
import CartPayMethods from "./CartOrderInformationPaymethods"
import CartTransportMethod from "./CartOrderInformationTransportMethod"
import CartDynamicFields from "@/components/cart/CartOrderInformationDynamicFields"

export default {
  components: {
    CartDynamicFields,
    CartTransportMethod,
    CartPayMethods,
    formElement,
    BRow,
    BCol,
    CartActionCode,
    AddressShipmentSelector,
  },
  props: {
    orderInformation: {
      type: Object,
      required: true,
      default: function () {
        return {}
      },
    },
    transportID: {
      type: Number,
      required: false,
      default: null,
    },
    paymethodID: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data: function () {
    return {
      form: { payMethodID: null },
      customerInvoiceAddress: {},
      loaded: false,
      selectedShipmentAddress: null,
      shipmentAddress: null,
      dynamicFields: {},
    }
  },
  computed: {
    orderInformationFields: function () {
      return orderInformationFields
    },
    deliveryAddressFields: function () {
      return deliveryAddressFields
    },
    invoiceAddressFields: function () {
      return invoiceAddressFields
    },
  },
  watch: {
    form: function (form) {
      this.$emit("update:orderInformation", form)
    },
    dynamicFields: {
      handler(dynamicFields) {
        this.form = { ...this.form, fields: { ...dynamicFields } }
      },
      deep: true,
    },
    shipmentAddress: function (address) {
      if (address === null) return
      const form = {
        shipmentAddressID: address.addressID,
        shipmentCity: address.city,
        shipmentCompanyName: address.companyName,
        shipmentCountryID: address.countryID,
        shipmentFirstName: address.firstName,
        shipmentHouseNumber: address.houseNumber,
        shipmentHouseNumberAddition: address.houseNumberAddition,
        shipmentLastName: address.lastname,
        shipmentSalutation: address.salutation,
        shipmentStreet: address.street,
        shipmentTel: address.tel,
        shipmentZipCode: address.zipCode,
      }

      this.form = { ...this.form, ...form }
    },
  },
  created: async function () {
    this.customerInvoiceAddress = await getCustomerInvoiceAddress()
    this.form = {
      ...this.customerInvoiceAddress,
      transportID: this.transportID,
      paymethodID: this.paymethodID,
    }
    this.loaded = true
  },
}
</script>

<style></style>
